// TODO: Deprecate this
export enum ProductCode {
  TPL = '0100',
  COMPREHENSIVE = '0110',
}
